"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendSizeSelector = void 0;
var legend_item_1 = require("../../components/legend/legend_item");
var position_style_1 = require("../../components/legend/position_style");
var canvas_text_bbox_calculator_1 = require("../../utils/bbox/canvas_text_bbox_calculator");
var common_1 = require("../../utils/common");
var create_selector_1 = require("../create_selector");
var get_chart_theme_1 = require("./get_chart_theme");
var get_legend_config_selector_1 = require("./get_legend_config_selector");
var get_legend_items_labels_1 = require("./get_legend_items_labels");
var getParentDimensionSelector = function (state) { return state.parentDimensions; };
var SCROLL_BAR_WIDTH = 16;
var MARKER_WIDTH = 16;
var SHARED_MARGIN = 4;
var VERTICAL_PADDING = 4;
var TOP_MARGIN = 2;
exports.getLegendSizeSelector = create_selector_1.createCustomCachedSelector([get_legend_config_selector_1.getLegendConfigSelector, get_chart_theme_1.getChartThemeSelector, getParentDimensionSelector, get_legend_items_labels_1.getLegendItemsLabelsSelector], function (legendConfig, theme, parentDimensions, labels) {
    if (!legendConfig.showLegend) {
        return { width: 0, height: 0, margin: 0, position: position_style_1.LEGEND_TO_FULL_CONFIG[common_1.Position.Right] };
    }
    var bboxCalculator = new canvas_text_bbox_calculator_1.CanvasTextBBoxCalculator();
    var bbox = labels.reduce(function (acc, _a) {
        var label = _a.label, depth = _a.depth;
        var labelBBox = bboxCalculator.compute(label, 1, 12, '"Inter UI", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"', 1.5, 400);
        labelBBox.width += depth * legend_item_1.LEGEND_HIERARCHY_MARGIN;
        if (acc.height < labelBBox.height) {
            acc.height = labelBBox.height;
        }
        if (acc.width < labelBBox.width) {
            acc.width = labelBBox.width;
        }
        return acc;
    }, { width: 0, height: 0 });
    bboxCalculator.destroy();
    var showLegendDisplayValue = legendConfig.showLegendExtra, legendPosition = legendConfig.legendPosition, legendAction = legendConfig.legendAction;
    var _a = theme.legend, verticalWidth = _a.verticalWidth, spacingBuffer = _a.spacingBuffer, margin = _a.margin;
    var actionDimension = common_1.isDefined(legendAction) ? 24 : 0;
    var legendItemWidth = MARKER_WIDTH + SHARED_MARGIN + bbox.width + (showLegendDisplayValue ? SHARED_MARGIN : 0);
    if (legendPosition.direction === common_1.LayoutDirection.Vertical) {
        var legendItemHeight = bbox.height + VERTICAL_PADDING * 2;
        var legendHeight = legendItemHeight * labels.length + TOP_MARGIN;
        var scrollBarDimension = legendHeight > parentDimensions.height ? SCROLL_BAR_WIDTH : 0;
        return {
            width: Math.floor(Math.min(legendItemWidth + spacingBuffer + actionDimension + scrollBarDimension, verticalWidth)),
            height: legendHeight,
            margin: margin,
            position: legendPosition,
        };
    }
    var isSingleLine = (parentDimensions.width - 20) / 200 > labels.length;
    return {
        height: isSingleLine ? bbox.height + 16 : bbox.height * 2 + 24,
        width: Math.floor(Math.min(legendItemWidth + spacingBuffer + actionDimension, verticalWidth)),
        margin: margin,
        position: legendPosition,
    };
});
//# sourceMappingURL=get_legend_size.js.map